import { useEffect, useMemo, useRef, useState } from 'react';

// Derive a simple "energy" scalar from live visitors + player counts, inspired by useGuestSignals.
export default function useGuestEnergy({ liveCount = 0, playerStats }) {
  const [energy, setEnergy] = useState(0.2);
  const lastChangeRef = useRef(Date.now());

  const total = useMemo(() => {
    const online = playerStats?.online || 0;
    const idle = playerStats?.idle || 0;
    return Number(liveCount || 0) + online + idle;
  }, [liveCount, playerStats?.online, playerStats?.idle]);

  // Track changes to total to add a brief boost
  const boostedTarget = useMemo(() => {
    const base = Math.min(1.1, 0.18 + Math.min(total, 15) * 0.09);
    const boost = Date.now() - lastChangeRef.current < 2500 ? 0.35 : 0;
    return Math.max(0.18, base + boost);
  }, [total]);

  useEffect(() => {
    lastChangeRef.current = Date.now();
  }, [total]);

  useEffect(() => {
    const tick = setInterval(() => {
      setEnergy((prev) => prev + (boostedTarget - prev) * 0.3);
    }, 400);
    return () => clearInterval(tick);
  }, [boostedTarget]);

  return energy;
}
